var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showSearchResults
    ? _c(
        "ul",
        { staticClass: "search-results" },
        _vm._l(_vm.items, function (item, id) {
          return _c(
            "li",
            {
              class: { active: id === _vm.activeItemId },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.selectItem(item)
                },
              },
            },
            [_vm._v(_vm._s(item) + "\n    ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }